import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { ZoomIn } from '@mui/icons-material';

import NotificationDetailForm from './NotificationDetailForm';
import NotificationDialog from './NotificationDialog';
import MarkNotificationViewedMutation from './MarkNotificationViewedMutation';
import { format } from 'date-fns';

const styleSheet = theme => ({
    paper: {
        marginTop: theme.spacing(1),
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCellLeft: {
      textAlign: 'left',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    detailIcon: {
      width: 22,
      height: 22,
    },
    [theme.breakpoints.up('sm')]: {
      tblCellDateCol: {
        paddingLeft: 10,
        paddingRight: 10,
        minWidth: 140,
        width: 160,
      },
      tblCellTypeCol: {
        paddingLeft: 10,
        paddingRight: 10,
        minWidth: 60,
        width: 80,
      },
      tblCellDescCol: {
        paddingLeft: 10,
        paddingRight: 10,
        minWidth: 140,
        width: 260,
      }
    },
    [theme.breakpoints.up('xs')]: {
      tblCellDateCol: {

      },
      tblCellTypeCol: {
  
      },
      tblCellDescCol: {
  
      }
    },
  
});

class NotificationsList extends React.Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      detailOpen: false,
      notificationUserId: null,
      notificationId: null,
      userId: props.userId,
      notificationTime: null,
      notificationSubject: null,
      notificationBody: null
    };
  }

  showDetail(notificationUserId, notificationId, notificationTime, notificationSubject, notificationBody) {
    this.setState({notificationUserId: notificationUserId, 
                   notificationId: notificationId, 
                   notificationTime: notificationTime,
                   notificationSubject: notificationSubject,
                   notificationBody: notificationBody,
                   detailOpen: true});
    //alert(notificationId);
   }        


  markedViewedAndClose = () => {
    Promise.resolve()
    .then(() => {
      return MarkNotificationViewedMutation.commit(this.state.notificationUserId,
                                                   this.state.notificationId,
                                                   this.state.userId,
                                                   1);
    })
    .then(updateResult => {
      //close window
      this.setState({detailOpen: false});
      window.location.reload();
    })
    .catch(err => {
      //eat for now
       window.location.reload();
    });
  }

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.al.nodes;

    return (
    <div className={classes.paper}>
    <TableContainer>
      <Table>
        <TableHead className={classes.tblHead}>
          <TableRow className={classes.tblHeadRow}>
            <TableCell className={classes.tblHeadCellLeft}>Timestamp</TableCell>
            <TableCell className={classes.tblHeadCellLeft}>Severity</TableCell>
            <TableCell className={classes.tblHeadCellLeft}>Type</TableCell>
            <TableCell className={classes.tblHeadCellLeft}>Subject</TableCell>
            <TableCell className={classes.tblHeadCellLeft}>Viewed</TableCell>
            <TableCell className={classes.tblHeadCellLeft}>Detail</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { thenodes.map(n => {

            //notificationtime as 2019-12-03 19:50:11.354291 (excludes Z)
            let atime = format(new Date(n.notificationTime+'Z'), 'yyyy-MM-dd pp');
            let viewed = 'Yes';
            if (n.viewed == null || n.viewed === 0) {
              viewed = "No"
            }

            // Massage data
            let theSeverity = n.severity;
            if (theSeverity === 'error') {
              theSeverity = 'Error';
            } else if (theSeverity === 'warning') {
              theSeverity = 'Warning';
            } else if (theSeverity === 'info') {
              theSeverity = 'Info';
            }

            let theType = n.notificationType;
            if (theType === 'cc') {
              theType = 'Credit card';
            } else if (theType === 'ach') {
              theType = 'ACH';
            } else if (theType === 'ach_create') {
              theType = 'ACH';
            } else if (theType === 'ach_failure') {
              theType = 'ACH';
            } else if (theType === 'ach_verification') {
              theType = 'ACH';
            } else if (theType === 'subscription') {
              theType = 'Subscription';
            } else if (theType === 'transfer') {
              theType = 'Transfer';
            } else if (theType === 'transfer_cancelled') {
              theType = 'Transfer';
            } else if (theType === 'transfer_confirmed') {
              theType = 'Transfer';
            } else if (theType === 'verification') {
              theType = 'Verification';
            } else if (theType === 'pmt_source_fail') {
              theType = 'Funding source';
            } else if (theType === 'pmt_source_cust_fail') {
              theType = 'Funding source';
            } else if (theType === 'test') {
              theType = 'Test';
            } else if (theType === 'so_accept') {
              theType = 'Subscription order';
            } else if (theType === 'budget_change') {
              theType = 'Budget change';
            } else if (theType === 'account_status') {
              theType = 'Account status';
            } else if (theType === 'topup_activity') {
              theType = 'Topup';
            } else if (theType === 'account_upgraded') {
              theType = 'Transferred';
            } else if (theType.startsWith('bindcard')) {
              theType = 'Bindcard';
            } else if (theType.startsWith('payout')) {
              theType = 'Payout';
            } else if (theType.startsWith('increase')) {
              theType = 'Increase';
            } else if (theType.startsWith('service')) {
              theType = 'Service';
            }


            return (
              <TableRow key={n.notificationId} 
                        onClick={() => {
                          this.showDetail(n.notificationUserId, 
                            n.notificationId, 
                            n.notificationTime, 
                            n.notificationSubject, 
                            n.notificationBody)
                        }}>
                <TableCell className={classes.tblCellDateCol}>{atime}</TableCell>
                <TableCell className={classes.tblCellTypeCol}>{theSeverity}</TableCell>
                <TableCell className={classes.tblCellTypeCol}>{theType}</TableCell>
                <TableCell className={classes.tblCellDescCol}>{n.notificationSubject}</TableCell>
                <TableCell className={classes.tblCellTypeCol}>{viewed}</TableCell>
                <TableCell className={classes.tblCellTypeCol}>
                    <Button
                        className={classes.iconbutton}
                        color="primary"
                        onClick={() => {
                          this.showDetail(n.notificationUserId, 
                                          n.notificationId, 
                                          n.userId,
                                          n.notificationTime, 
                                          n.notificationSubject, 
                                          n.notificationBody)
                          }}>
                      <ZoomIn className={classes.detailIcon}/>
                    </Button>
                </TableCell>
            </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>

    <NotificationDialog
        title="Notification detail"
        open={this.state.detailOpen}
        onClose={this.markedViewedAndClose} >
        <NotificationDetailForm 
                  auth={this.props.auth}
                  notificationId={this.state.notificationId}
                  notificationUserId={this.state.notificationUserId}
                  userId={this.state.userId}
                  notificationTime={this.state.notificationTime}
                  notificationSubject={this.state.notificationSubject}
                  notificationBody={this.state.notificationBody}
                  onClose={this.markedViewedAndClose}
                />
    </NotificationDialog>

    </div>
    );
  } // end render()
}

NotificationsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(NotificationsList), { al: graphql`
  fragment NotificationsList_al on NotificationEntriesConnection {
    nodes {
      notificationId
      accountId
      userId
      notificationType
      notificationSubject
      notificationBody
      notificationTime
      severity
      notificationUserId
      viewed
    }
  }
` });
